var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalEnvoiCommande",
      attrs: {
        size: "lg",
        title: "Passer la commande au statut 'Envoyé'",
        "ok-title": "Modifier le statut",
        "ok-disabled": !_vm.fournisseursSelectionnesPourEnvoi.length,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        ok: function($event) {
          return _vm.send()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("p", [
          _vm._v(
            "Les commandes sélectionnées seront considérées comme envoyées au fournisseur."
          )
        ]),
        _c("p", [
          _vm._v(
            "Cette fonctionnalité est à utiliser lorsque vous avez passé votre commande par téléphone ou que vous avez envoyé le bon de commande manuellement."
          )
        ]),
        _c("p", [_c("b", [_vm._v("Cette action est irréversible.")])]),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header flex-start" }, [
            _c("label", { staticClass: "label-checkbox mb-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.envoyerTout,
                    expression: "envoyerTout"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.envoyerTout)
                    ? _vm._i(_vm.envoyerTout, null) > -1
                    : _vm.envoyerTout
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.envoyerTout,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.envoyerTout = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.envoyerTout = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.envoyerTout = $$c
                      }
                    },
                    function($event) {
                      return _vm.checkAllEnvoi()
                    }
                  ]
                }
              }),
              _c("span", { staticClass: "ml-2" }, [_vm._v("Fournisseurs")])
            ])
          ]),
          _c(
            "div",
            { staticClass: "card-body" },
            _vm._l(_vm.fournisseurs, function(fournisseur, index) {
              return _c("div", { key: index, staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c("label", { staticClass: "label-checkbox mb-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: fournisseur.envoi,
                          expression: "fournisseur.envoi"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        disabled: !fournisseur.dateLivraisonSouhaitee
                      },
                      domProps: {
                        checked: Array.isArray(fournisseur.envoi)
                          ? _vm._i(fournisseur.envoi, null) > -1
                          : fournisseur.envoi
                      },
                      on: {
                        change: function($event) {
                          var $$a = fournisseur.envoi,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  fournisseur,
                                  "envoi",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  fournisseur,
                                  "envoi",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(fournisseur, "envoi", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" " + _vm._s(fournisseur.nom) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-6 flex-end" }, [
                  fournisseur.dateLivraisonSouhaitee
                    ? _c("span", [
                        _vm._v(
                          "Livraison demandée le " +
                            _vm._s(fournisseur.dateLivraisonSouhaitee)
                        )
                      ])
                    : _c("em", { staticClass: "error ml-2" }, [
                        _c("i", {
                          staticClass:
                            "fas fa-exclamation-triangle ligne-modifiee"
                        }),
                        _vm._v(" Aucune date de livraison renseignée ")
                      ])
                ])
              ])
            }),
            0
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }